import React, { useContext, useEffect, useState } from "react";
import QuoteAuditsFilters from "../../components/tables/QuoteAuditsFilters";
import { fetchData } from "../../utils/dataProvider";
import {
  GET,
  INFO,
  MARKETPLACE,
  MEDIUM,
  MERCHANT,
  ROWS_PER_PAGE,
} from "../../utils/constants";
import { Grid } from "@mui/material";
import Loader from "../../components/Loader";
import ListQuoteAudits from "../../components/tables/ListQuoteAudits";
import { IAlert } from "../../interfaces/alert";
import GenericAlert from "../../components/GenericAlert";
import { UserContext } from "../../contexts/userContext";
import { IQuoteAudit } from "../../interfaces/order";
import { IPaginationParams } from "../../interfaces/table";

const QuotesAudits = () => {
  const {
    currentUser: { entity },
    selectedMarketplace,
  } = useContext(UserContext);
  const [audits, setAudits] = useState<IQuoteAudit[]>([]);
  const [alert, setAlert] = useState<IAlert>({} as IAlert);
  const [loading, setLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState({
    count: 0,
    page: 0,
  } as IPaginationParams);
  const [filters, setFilters] = useState<any>({});
  const [merchants, setMerchants] = useState<{ id: number; name: string }[]>(
    []
  );

  const getQuoteAudits = async (newPage = 0, appliedFilters = filters) => {
    setLoading(true);
    const skip = newPage * ROWS_PER_PAGE;
    const useMarketplaceid =
      entity === MERCHANT ? `&marketplaceId=${selectedMarketplace}` : "";
    let filterParams = "";
    if (appliedFilters.fromDate)
      filterParams += `&fromDate=${appliedFilters.fromDate}`;
    if (appliedFilters.toDate)
      filterParams += `&toDate=${appliedFilters.toDate}`;
    if (appliedFilters.merchantId)
      filterParams += `&merchantId=${appliedFilters.merchantId}`;
    if (appliedFilters.allResponsesFailed)
      filterParams += "&allResponsesFailed=true";
    try {
      const {
        data: { count, audits: fetchAudits },
      } = await fetchData({
        url: `/orders/audit/quotes?limit=${ROWS_PER_PAGE}&skip=${skip}${useMarketplaceid}${filterParams}`,
        method: GET,
      });
      setAudits(fetchAudits);
      setPagination({ count, page: newPage });
      if (fetchAudits.length === 0)
        setAlert({
          typeOfAlert: INFO,
          message: "No hay cotizaciones para mostrar.",
          showAlert: true,
        });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage: number) => getQuoteAudits(newPage);

  const handleFilter = (newFilters: any) => {
    setFilters(newFilters);
    getQuoteAudits(0, newFilters);
  };

  const getListOfMerchants = async () => {
    {
      try {
        const { integrations } = await fetchData({
          url: "/marketplaces_merchants/acceptedIntegrationsOfMarketplace",
          method: GET,
        });
        const parsedMerchants = integrations.map(({ merchant }: any) => ({
          id: merchant.id,
          name: merchant.entity.name,
        }));
        setMerchants(parsedMerchants);
      } catch (error: any) {
        setAlert({ typeOfAlert: "error", message: error, showAlert: true });
      }
    }
  };
  useEffect(() => {
    getQuoteAudits();
    if (entity === MARKETPLACE) getListOfMerchants();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <QuoteAuditsFilters merchants={merchants} onFilter={handleFilter} />
      </Grid>
      {loading ? (
        <Grid container justifyContent="center">
          <Loader size={MEDIUM} />
        </Grid>
      ) : (
        <>
          {alert.showAlert && (
            <Grid item xs={12}>
              <GenericAlert alert={alert} />
            </Grid>
          )}
          {audits && !alert.showAlert && (
            <ListQuoteAudits
              audits={audits}
              pagination={pagination}
              handlePageChange={handlePageChange}
            />
          )}
        </>
      )}
    </Grid>
  );
};

export default QuotesAudits;
